var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarwynnAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1008,
    height: 1008,
    viewBox: "0 0 1008 1008",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.599 1000C360.887 1000 233.768 945.422 139.647 846.315C-41.2838 655.797 -41.2067 357.39 139.825 166.964L152.626 153.499C246.731 54.5165 373.789 -2.31732e-05 510.401 -2.31732e-05C647.113 -2.31732e-05 774.232 54.5783 868.353 153.685C1049.28 344.203 1049.21 642.61 868.175 833.036L855.382 846.501C761.276 945.491 634.211 1000 497.599 1000Z",
    fill: "#4898D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M817.641 231.56C816.809 231.56 815.961 231.634 815.12 231.788L700.432 252.45C694.888 253.452 690.868 257.677 690.868 262.497V329.897C690.868 335.559 696.278 340.165 702.928 340.165H817.617C824.268 340.165 829.685 335.559 829.685 329.897V241.835C829.685 238.72 828.052 235.812 825.218 233.853C823.043 232.356 820.373 231.56 817.641 231.56ZM817.617 347.578H702.928C691.481 347.578 682.161 339.644 682.161 329.897V262.497C682.161 254.194 689.086 246.922 698.626 245.204L813.322 224.542C819.47 223.432 825.807 224.722 830.698 228.098C835.582 231.473 838.385 236.474 838.385 241.835V329.897C838.385 339.644 829.073 347.578 817.617 347.578Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.028 784.774C226.028 783.972 225.966 783.21 225.848 782.475C225.722 781.739 225.463 781.098 225.055 780.543C224.647 779.988 224.05 779.554 223.257 779.233C222.472 778.912 221.419 778.751 220.085 778.751C218.664 778.751 217.509 778.905 216.614 779.213C215.719 779.52 215.02 779.968 214.502 780.563C213.984 781.158 213.623 781.873 213.411 782.729C213.199 783.578 213.081 784.534 213.05 785.583L226.028 784.774ZM229.884 784.734C229.884 785.022 229.868 785.376 229.821 785.797C229.774 786.225 229.719 786.686 229.656 787.174L213.05 788.056C213.05 789.193 213.191 790.175 213.458 791.011C213.733 791.853 214.172 792.542 214.777 793.083C215.382 793.618 216.182 794.026 217.18 794.3C218.177 794.567 219.417 794.701 220.901 794.701C222.26 794.701 223.642 794.574 225.055 794.32C226.46 794.059 227.63 793.738 228.564 793.351V796.406C228.211 796.559 227.74 796.713 227.167 796.867C226.586 797.02 225.934 797.161 225.212 797.274C224.489 797.388 223.704 797.475 222.88 797.542C222.04 797.609 221.184 797.642 220.305 797.642C218.499 797.642 216.889 797.462 215.476 797.114C214.07 796.766 212.885 796.178 211.911 795.343C210.945 794.5 210.215 793.397 209.713 792.02C209.218 790.643 208.967 788.912 208.967 786.82C208.967 784.734 209.218 783.003 209.713 781.626C210.215 780.249 210.938 779.139 211.888 778.304C212.846 777.468 214.015 776.873 215.389 776.526C216.763 776.178 218.326 776.004 220.085 776.004C222.173 776.004 223.861 776.265 225.141 776.8C226.429 777.321 227.418 778.009 228.117 778.845C228.816 779.681 229.287 780.623 229.522 781.659C229.766 782.709 229.884 783.725 229.884 784.734Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.791 783.998H249.177V786.779H235.791V783.998Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.507 797.64C264.693 797.64 263.084 797.459 261.678 797.118C260.265 796.771 259.079 796.176 258.114 795.34C257.148 794.498 256.41 793.395 255.915 792.018C255.413 790.641 255.161 788.91 255.161 786.824C255.161 784.732 255.413 783.007 255.915 781.624C256.41 780.247 257.148 779.137 258.114 778.301C259.079 777.466 260.265 776.871 261.678 776.523C263.084 776.176 264.693 776.002 266.507 776.002C267.873 776.002 269.098 776.082 270.205 776.236C271.312 776.389 272.207 776.57 272.906 776.777V779.832C272.003 779.545 271.03 779.317 270.001 779.15C268.972 778.983 267.826 778.903 266.554 778.903C265.188 778.903 264.057 779.03 263.146 779.284C262.236 779.545 261.505 779.979 260.924 780.581C260.351 781.189 259.943 781.998 259.7 783.014C259.464 784.03 259.338 785.313 259.338 786.858C259.338 788.382 259.464 789.645 259.7 790.648C259.943 791.65 260.351 792.459 260.924 793.061C261.505 793.669 262.251 794.09 263.178 794.338C264.097 794.578 265.235 794.705 266.601 794.705C267.748 794.705 268.886 794.632 270.001 794.491C271.124 794.351 272.121 794.124 273 793.816V796.864C272.663 796.965 272.247 797.065 271.752 797.159C271.249 797.245 270.708 797.332 270.119 797.406C269.522 797.486 268.917 797.54 268.305 797.58C267.677 797.62 267.08 797.64 266.507 797.64Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.062 794.818C290.452 794.818 291.614 794.691 292.54 794.43C293.459 794.176 294.189 793.742 294.739 793.12C295.281 792.499 295.665 791.676 295.893 790.647C296.113 789.618 296.231 788.341 296.231 786.823C296.231 785.306 296.113 784.029 295.87 783C295.626 781.964 295.226 781.141 294.668 780.526C294.103 779.911 293.365 779.457 292.446 779.19C291.52 778.922 290.397 778.788 289.062 778.788C287.696 778.788 286.557 778.922 285.639 779.19C284.712 779.457 283.974 779.911 283.417 780.526C282.852 781.141 282.459 781.964 282.231 783C282.011 784.029 281.894 785.306 281.894 786.823C281.894 788.341 282.019 789.618 282.255 790.647C282.498 791.676 282.906 792.499 283.48 793.12C284.061 793.742 284.791 794.176 285.702 794.43C286.612 794.691 287.727 794.818 289.062 794.818ZM289.062 797.639C287.248 797.639 285.639 797.465 284.233 797.118C282.82 796.77 281.635 796.182 280.669 795.34C279.703 794.504 278.965 793.401 278.462 792.017C277.96 790.64 277.717 788.909 277.717 786.823C277.717 784.738 277.96 783.006 278.462 781.623C278.965 780.246 279.703 779.136 280.669 778.301C281.635 777.465 282.82 776.87 284.233 776.522C285.639 776.175 287.248 776.001 289.062 776.001C290.876 776.001 292.485 776.175 293.899 776.522C295.304 776.87 296.482 777.465 297.432 778.301C298.39 779.136 299.112 780.246 299.615 781.623C300.109 783.006 300.361 784.738 300.361 786.823C300.361 788.909 300.109 790.64 299.615 792.017C299.112 793.401 298.39 794.504 297.432 795.34C296.482 796.182 295.304 796.77 293.899 797.118C292.485 797.465 290.876 797.639 289.062 797.639Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.947 776.004C334.368 776.004 335.585 776.171 336.598 776.505C337.611 776.839 338.443 777.314 339.103 777.915C339.746 778.524 340.225 779.246 340.524 780.081C340.822 780.917 340.979 781.839 340.979 782.842V797.254H337.077V784.038C337.077 782.421 336.747 781.164 336.103 780.295C335.452 779.413 334.203 778.978 332.358 778.978C331.628 778.978 330.945 779.032 330.293 779.139C329.641 779.232 329.045 779.419 328.503 779.693C327.953 779.961 327.474 780.335 327.042 780.816C326.618 781.291 326.273 781.899 326.006 782.648V782.808V797.254H322.104V784.038C322.104 782.448 321.798 781.204 321.193 780.308C320.581 779.419 319.387 778.978 317.605 778.978C316.851 778.978 316.137 779.025 315.477 779.112C314.81 779.205 314.205 779.386 313.663 779.653C313.114 779.927 312.627 780.308 312.211 780.816C311.787 781.318 311.418 781.966 311.111 782.762V797.254H307.209V776.391H311.111V779.139C311.873 777.895 312.87 777.066 314.111 776.639C315.351 776.217 316.71 776.004 318.202 776.004C320.133 776.004 321.68 776.311 322.826 776.913C323.972 777.521 324.805 778.35 325.323 779.406C325.684 778.738 326.147 778.176 326.705 777.742C327.262 777.307 327.89 776.959 328.566 776.699C329.249 776.438 329.963 776.264 330.701 776.164C331.439 776.057 332.185 776.004 332.947 776.004Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.742 776.004C376.163 776.004 377.38 776.171 378.4 776.505C379.405 776.839 380.238 777.314 380.889 777.915C381.541 778.524 382.02 779.246 382.318 780.081C382.617 780.917 382.774 781.839 382.774 782.842V797.254H378.872V784.038C378.872 782.421 378.542 781.164 377.898 780.295C377.246 779.413 375.998 778.978 374.153 778.978C373.422 778.978 372.739 779.032 372.088 779.139C371.436 779.232 370.839 779.419 370.298 779.693C369.748 779.961 369.269 780.335 368.837 780.816C368.413 781.291 368.068 781.899 367.801 782.648V782.808V797.254H363.898V784.038C363.898 782.448 363.592 781.204 362.988 780.308C362.375 779.419 361.182 778.978 359.399 778.978C358.646 778.978 357.939 779.025 357.272 779.112C356.604 779.205 356 779.386 355.458 779.653C354.908 779.927 354.429 780.308 354.005 780.816C353.581 781.318 353.212 781.966 352.906 782.762V797.254H349.004V776.391H352.906V779.139C353.668 777.895 354.665 777.066 355.905 776.639C357.146 776.217 358.504 776.004 359.996 776.004C361.928 776.004 363.474 776.311 364.621 776.913C365.767 777.521 366.599 778.35 367.118 779.406C367.479 778.738 367.942 778.176 368.5 777.742C369.057 777.307 369.685 776.959 370.36 776.699C371.043 776.438 371.758 776.264 372.496 776.164C373.234 776.057 373.98 776.004 374.742 776.004Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.415 784.774C406.415 783.972 406.352 783.21 406.234 782.475C406.108 781.739 405.849 781.098 405.441 780.543C405.033 779.988 404.436 779.554 403.643 779.233C402.858 778.912 401.798 778.751 400.471 778.751C399.05 778.751 397.896 778.905 397.001 779.213C396.105 779.52 395.407 779.968 394.888 780.563C394.37 781.158 394.009 781.873 393.805 782.729C393.585 783.578 393.467 784.534 393.436 785.583L406.415 784.774ZM410.27 784.734C410.27 785.022 410.254 785.376 410.207 785.797C410.16 786.225 410.105 786.686 410.042 787.174L393.436 788.056C393.436 789.193 393.577 790.175 393.844 791.011C394.119 791.853 394.559 792.542 395.163 793.083C395.768 793.618 396.569 794.026 397.566 794.3C398.563 794.567 399.804 794.701 401.288 794.701C402.646 794.701 404.028 794.574 405.441 794.32C406.846 794.059 408.016 793.738 408.951 793.351V796.406C408.597 796.559 408.126 796.713 407.553 796.867C406.972 797.02 406.328 797.161 405.598 797.274C404.876 797.388 404.091 797.475 403.266 797.542C402.426 797.609 401.578 797.642 400.699 797.642C398.885 797.642 397.275 797.462 395.862 797.114C394.457 796.766 393.271 796.178 392.297 795.343C391.332 794.5 390.601 793.397 390.099 792.02C389.604 790.643 389.353 788.912 389.353 786.82C389.353 784.734 389.604 783.003 390.099 781.626C390.601 780.249 391.324 779.139 392.282 778.304C393.232 777.468 394.402 776.873 395.776 776.526C397.15 776.178 398.712 776.004 400.471 776.004C402.559 776.004 404.248 776.265 405.527 776.8C406.815 777.321 407.804 778.009 408.503 778.845C409.202 779.681 409.673 780.623 409.909 781.659C410.152 782.709 410.27 783.725 410.27 784.734Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.197 776.004L429.064 779.018H428.522C427.729 779.018 426.96 779.085 426.206 779.212C425.444 779.339 424.738 779.58 424.062 779.927C423.403 780.275 422.798 780.743 422.256 781.338C421.715 781.926 421.275 782.688 420.937 783.617V797.254H417.035V776.391H420.937V780.175C421.33 779.299 421.817 778.591 422.39 778.049C422.963 777.508 423.599 777.08 424.298 776.779C424.989 776.465 425.727 776.264 426.496 776.164C427.266 776.057 428.02 776.004 428.742 776.004H429.197Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.266 797.64C441.452 797.64 439.842 797.459 438.437 797.118C437.023 796.771 435.838 796.176 434.872 795.34C433.906 794.498 433.168 793.395 432.666 792.018C432.163 790.641 431.92 788.91 431.92 786.824C431.92 784.732 432.163 783.007 432.666 781.624C433.168 780.247 433.906 779.137 434.872 778.301C435.838 777.466 437.023 776.871 438.437 776.523C439.842 776.176 441.452 776.002 443.266 776.002C444.632 776.002 445.857 776.082 446.964 776.236C448.063 776.389 448.966 776.57 449.665 776.777V779.832C448.754 779.545 447.788 779.317 446.76 779.15C445.731 778.983 444.585 778.903 443.313 778.903C441.946 778.903 440.816 779.03 439.905 779.284C438.994 779.545 438.256 779.979 437.683 780.581C437.11 781.189 436.702 781.998 436.458 783.014C436.215 784.03 436.097 785.313 436.097 786.858C436.097 788.382 436.215 789.645 436.458 790.648C436.702 791.65 437.11 792.459 437.683 793.061C438.256 793.669 439.002 794.09 439.929 794.338C440.855 794.578 441.994 794.705 443.36 794.705C444.506 794.705 445.637 794.632 446.76 794.491C447.874 794.351 448.879 794.124 449.759 793.816V796.864C449.421 796.965 449.005 797.065 448.503 797.159C448 797.245 447.466 797.332 446.869 797.406C446.281 797.486 445.676 797.54 445.056 797.58C444.435 797.62 443.839 797.64 443.266 797.64Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.535 784.774C471.535 783.972 471.473 783.21 471.355 782.475C471.229 781.739 470.97 781.098 470.562 780.543C470.154 779.988 469.557 779.554 468.764 779.233C467.979 778.912 466.919 778.751 465.592 778.751C464.171 778.751 463.016 778.905 462.121 779.213C461.226 779.52 460.52 779.968 460.009 780.563C459.491 781.158 459.13 781.873 458.926 782.729C458.706 783.578 458.588 784.534 458.557 785.583L471.535 784.774ZM475.391 784.734C475.391 785.022 475.375 785.376 475.328 785.797C475.281 786.225 475.226 786.686 475.163 787.174L458.557 788.056C458.557 789.193 458.698 790.175 458.965 791.011C459.24 791.853 459.68 792.542 460.284 793.083C460.889 793.618 461.69 794.026 462.687 794.3C463.692 794.567 464.924 794.701 466.408 794.701C467.767 794.701 469.149 794.574 470.562 794.32C471.967 794.059 473.137 793.738 474.079 793.351V796.406C473.718 796.559 473.247 796.713 472.674 796.867C472.093 797.02 471.449 797.161 470.719 797.274C469.997 797.388 469.211 797.475 468.387 797.542C467.547 797.609 466.699 797.642 465.819 797.642C464.006 797.642 462.396 797.462 460.983 797.114C459.577 796.766 458.392 796.178 457.418 795.343C456.452 794.5 455.722 793.397 455.22 792.02C454.725 790.643 454.474 788.912 454.474 786.82C454.474 784.734 454.725 783.003 455.22 781.626C455.722 780.249 456.445 779.139 457.403 778.304C458.353 777.468 459.522 776.873 460.897 776.526C462.271 776.178 463.833 776.004 465.592 776.004C467.68 776.004 469.368 776.265 470.648 776.8C471.936 777.321 472.925 778.009 473.624 778.845C474.323 779.681 474.794 780.623 475.029 781.659C475.273 782.709 475.391 783.725 475.391 784.734Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.092 784.774C521.092 783.972 521.029 783.21 520.911 782.475C520.785 781.739 520.526 781.098 520.118 780.543C519.71 779.988 519.113 779.554 518.32 779.233C517.535 778.912 516.475 778.751 515.148 778.751C513.727 778.751 512.565 778.905 511.678 779.213C510.782 779.52 510.076 779.968 509.558 780.563C509.047 781.158 508.686 781.873 508.474 782.729C508.262 783.578 508.144 784.534 508.113 785.583L521.092 784.774ZM524.947 784.734C524.947 785.022 524.923 785.376 524.876 785.797C524.837 786.225 524.782 786.686 524.719 787.174L508.113 788.056C508.113 789.193 508.246 790.175 508.521 791.011C508.788 791.853 509.228 792.542 509.84 793.083C510.437 793.618 511.246 794.026 512.243 794.3C513.24 794.567 514.481 794.701 515.965 794.701C517.323 794.701 518.705 794.574 520.118 794.32C521.523 794.059 522.693 793.738 523.628 793.351V796.406C523.274 796.559 522.803 796.713 522.222 796.867C521.649 797.02 520.997 797.161 520.275 797.274C519.553 797.388 518.768 797.475 517.935 797.542C517.103 797.609 516.247 797.642 515.368 797.642C513.554 797.642 511.944 797.462 510.539 797.114C509.134 796.766 507.948 796.178 506.974 795.343C506.009 794.5 505.278 793.397 504.776 792.02C504.273 790.643 504.03 788.912 504.03 786.82C504.03 784.734 504.273 783.003 504.776 781.626C505.278 780.249 506.001 779.139 506.951 778.304C507.909 777.468 509.071 776.873 510.453 776.526C511.827 776.178 513.389 776.004 515.148 776.004C517.236 776.004 518.917 776.265 520.204 776.8C521.492 777.321 522.481 778.009 523.18 778.845C523.871 779.681 524.342 780.623 524.586 781.659C524.829 782.709 524.947 783.725 524.947 784.734Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.035 776.389H531.984L539.42 793.929H539.702L546.871 776.389H551.001L541.83 797.252H537.198L528.035 776.389Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M565.017 794.818C566.407 794.818 567.569 794.691 568.488 794.43C569.414 794.176 570.145 793.742 570.694 793.12C571.236 792.499 571.621 791.676 571.848 790.647C572.068 789.618 572.186 788.341 572.186 786.823C572.186 785.306 572.068 784.029 571.825 783C571.581 781.964 571.181 781.141 570.616 780.526C570.058 779.911 569.32 779.457 568.402 779.19C567.475 778.922 566.352 778.788 565.017 778.788C563.651 778.788 562.513 778.922 561.594 779.19C560.668 779.457 559.922 779.911 559.372 780.526C558.807 781.141 558.414 781.964 558.187 783C557.967 784.029 557.849 785.306 557.849 786.823C557.849 788.341 557.967 789.618 558.21 790.647C558.454 791.676 558.862 792.499 559.435 793.12C560.016 793.742 560.746 794.176 561.657 794.43C562.568 794.691 563.683 794.818 565.017 794.818ZM565.017 797.639C563.204 797.639 561.594 797.465 560.189 797.118C558.775 796.77 557.59 796.182 556.624 795.34C555.658 794.504 554.92 793.401 554.418 792.017C553.915 790.64 553.672 788.909 553.672 786.823C553.672 784.738 553.915 783.006 554.418 781.623C554.92 780.246 555.658 779.136 556.624 778.301C557.59 777.465 558.775 776.87 560.189 776.522C561.594 776.175 563.204 776.001 565.017 776.001C566.831 776.001 568.441 776.175 569.846 776.522C571.26 776.87 572.437 777.465 573.387 778.301C574.345 779.136 575.068 780.246 575.57 781.623C576.065 783.006 576.316 784.738 576.316 786.823C576.316 788.909 576.065 790.64 575.57 792.017C575.068 793.401 574.345 794.504 573.387 795.34C572.437 796.182 571.26 796.77 569.846 797.118C568.441 797.465 566.831 797.639 565.017 797.639Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.617 797.488C586.803 797.488 585.444 797.14 584.534 796.438C583.623 795.75 583.167 794.613 583.167 793.042V767.895H587.078V792.193C587.078 793.25 587.25 793.931 587.619 794.239C587.981 794.553 588.554 794.707 589.347 794.707C589.614 794.707 589.912 794.693 590.226 794.667C590.548 794.64 590.87 794.586 591.2 794.513V797.254C590.839 797.334 590.454 797.387 590.046 797.427C589.637 797.461 589.158 797.488 588.617 797.488Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615.709 776.389V797.252H612.396L611.893 794.237C611.532 794.939 611.061 795.501 610.488 795.942C609.915 796.376 609.286 796.717 608.603 796.965C607.928 797.212 607.206 797.386 606.452 797.486C605.698 797.586 604.937 797.64 604.175 797.64C602.581 797.64 601.246 797.473 600.186 797.138C599.126 796.804 598.286 796.343 597.666 795.748C597.046 795.153 596.606 794.438 596.355 793.602C596.096 792.767 595.962 791.844 595.962 790.842V776.389H599.864V789.605C599.864 790.4 599.927 791.122 600.053 791.751C600.171 792.379 600.406 792.914 600.76 793.355C601.105 793.79 601.592 794.124 602.204 794.358C602.824 794.592 603.618 794.705 604.591 794.705C605.345 794.705 606.083 794.659 606.813 794.572C607.535 794.478 608.211 794.284 608.831 793.99C609.451 793.696 610.017 793.275 610.511 792.733C611.014 792.192 611.438 791.477 611.807 790.568V776.389H615.709Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631.59 794.703C632.132 794.703 632.611 794.683 633.019 794.643C633.427 794.609 633.843 794.549 634.267 794.469V797.29C633.78 797.343 633.333 797.39 632.909 797.43C632.485 797.464 632.014 797.484 631.496 797.484C630.137 797.484 628.999 797.403 628.072 797.236C627.154 797.069 626.392 796.742 625.803 796.247C625.214 795.759 624.79 795.084 624.539 794.221C624.272 793.359 624.146 792.243 624.146 790.879V779.174H620.519V776.387H624.146V771.447H628.049V776.387H634.134V779.174H628.049V790.685C628.049 791.508 628.096 792.176 628.182 792.697C628.276 793.212 628.449 793.62 628.708 793.914C628.967 794.208 629.321 794.415 629.776 794.529C630.232 794.643 630.836 794.703 631.59 794.703Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M639.263 776.391H643.165V797.253H639.263V776.391ZM641.257 772.567C640.378 772.567 639.765 772.447 639.42 772.219C639.074 771.985 638.902 771.444 638.902 770.595C638.902 769.719 639.074 769.171 639.42 768.951C639.765 768.73 640.378 768.623 641.257 768.623C642.074 768.623 642.662 768.73 643.024 768.951C643.385 769.171 643.573 769.719 643.573 770.595C643.573 771.444 643.385 771.985 643.024 772.219C642.662 772.447 642.074 772.567 641.257 772.567Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.316 794.818C662.706 794.818 663.86 794.691 664.786 794.43C665.713 794.176 666.443 793.742 666.993 793.12C667.526 792.499 667.919 791.676 668.147 790.647C668.367 789.618 668.484 788.341 668.484 786.823C668.484 785.306 668.359 784.029 668.123 783C667.88 781.964 667.479 781.141 666.914 780.526C666.357 779.911 665.619 779.457 664.692 779.19C663.773 778.922 662.651 778.788 661.316 778.788C659.95 778.788 658.811 778.922 657.893 779.19C656.966 779.457 656.22 779.911 655.663 780.526C655.105 781.141 654.713 781.964 654.485 783C654.265 784.029 654.147 785.306 654.147 786.823C654.147 788.341 654.265 789.618 654.508 790.647C654.752 791.676 655.16 792.499 655.733 793.12C656.306 793.742 657.045 794.176 657.955 794.43C658.866 794.691 659.981 794.818 661.316 794.818ZM661.316 797.639C659.502 797.639 657.893 797.465 656.487 797.118C655.074 796.77 653.888 796.182 652.915 795.34C651.957 794.504 651.219 793.401 650.716 792.017C650.214 790.64 649.97 788.909 649.97 786.823C649.97 784.738 650.214 783.006 650.716 781.623C651.219 780.246 651.957 779.136 652.915 778.301C653.888 777.465 655.074 776.87 656.487 776.522C657.893 776.175 659.502 776.001 661.316 776.001C663.13 776.001 664.739 776.175 666.145 776.522C667.558 776.87 668.736 777.465 669.686 778.301C670.644 779.136 671.366 780.246 671.868 781.623C672.363 783.006 672.614 784.738 672.614 786.823C672.614 788.909 672.363 790.64 671.868 792.017C671.366 793.401 670.644 794.504 669.686 795.34C668.736 796.182 667.558 796.77 666.145 797.118C664.739 797.465 663.13 797.639 661.316 797.639Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.219 776.004C692.821 776.004 694.156 776.171 695.208 776.505C696.268 776.839 697.108 777.314 697.736 777.915C698.357 778.524 698.788 779.232 699.048 780.061C699.307 780.883 699.432 781.799 699.432 782.808V797.254H695.491V784.038C695.491 783.243 695.428 782.528 695.302 781.899C695.185 781.264 694.949 780.736 694.604 780.308C694.25 779.887 693.771 779.56 693.175 779.326C692.57 779.092 691.777 778.978 690.811 778.978C690.018 778.978 689.264 779.025 688.519 779.112C687.78 779.205 687.09 779.399 686.43 779.693C685.778 779.988 685.189 780.402 684.663 780.95C684.137 781.492 683.705 782.227 683.368 783.156V797.254H679.466V776.391H683.368V779.366C683.737 778.697 684.208 778.143 684.797 777.708C685.386 777.267 686.03 776.926 686.728 776.685C687.419 776.438 688.157 776.264 688.927 776.164C689.696 776.057 690.458 776.004 691.219 776.004Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.509 776.391H711.411V797.253H707.509V776.391ZM709.511 772.567C708.632 772.567 708.019 772.447 707.674 772.219C707.328 771.985 707.148 771.444 707.148 770.595C707.148 769.719 707.328 769.171 707.674 768.951C708.019 768.73 708.632 768.623 709.511 768.623C710.32 768.623 710.916 768.73 711.278 768.951C711.639 769.171 711.819 769.719 711.819 770.595C711.819 771.444 711.639 771.985 711.278 772.219C710.916 772.447 710.32 772.567 709.511 772.567Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M725.348 797.488C724.735 797.488 724.099 797.461 723.416 797.427C722.733 797.387 722.066 797.34 721.398 797.294C720.731 797.24 720.118 797.173 719.561 797.08C719.004 796.993 718.548 796.906 718.218 796.832V793.971C718.642 794.072 719.153 794.179 719.742 794.279C720.338 794.379 720.943 794.473 721.579 794.553C722.215 794.627 722.859 794.687 723.51 794.72C724.154 794.767 724.759 794.78 725.301 794.78C727.169 794.78 728.59 794.553 729.54 794.105C730.498 793.657 730.977 792.808 730.977 791.572C730.977 790.957 730.907 790.449 730.765 790.048C730.64 789.647 730.365 789.312 729.972 789.045C729.58 788.778 729.03 788.53 728.323 788.33C727.609 788.122 726.659 787.902 725.481 787.668C724.115 787.414 723 787.12 722.121 786.786C721.241 786.451 720.55 786.05 720.04 785.582C719.522 785.121 719.161 784.573 718.949 783.925C718.737 783.283 718.627 782.521 718.627 781.645C718.627 779.947 719.365 778.584 720.825 777.547C722.301 776.518 724.5 776.003 727.436 776.003C728.606 776.003 729.784 776.07 730.946 776.197C732.116 776.324 733.003 776.491 733.6 776.698L733.333 779.519C732.634 779.285 731.778 779.098 730.75 778.938C729.713 778.784 728.63 778.711 727.475 778.711C725.756 778.711 724.46 778.911 723.597 779.325C722.733 779.74 722.301 780.535 722.301 781.725C722.301 782.26 722.372 782.701 722.513 783.035C722.647 783.37 722.882 783.664 723.212 783.904C723.542 784.152 724.013 784.359 724.617 784.526C725.222 784.693 726.007 784.867 726.981 785.048C728.371 785.328 729.556 785.629 730.545 785.95C731.527 786.277 732.32 786.679 732.924 787.153C733.529 787.628 733.969 788.216 734.244 788.905C734.511 789.606 734.652 790.455 734.652 791.458C734.652 793.544 733.851 795.074 732.265 796.037C730.679 797.006 728.371 797.488 725.348 797.488Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M767.142 776.004C768.563 776.004 769.78 776.171 770.801 776.505C771.806 776.839 772.638 777.314 773.298 777.915C773.942 778.524 774.421 779.246 774.719 780.081C775.018 780.917 775.175 781.839 775.175 782.842V797.254H771.272V784.038C771.272 782.421 770.943 781.164 770.299 780.295C769.647 779.413 768.399 778.978 766.553 778.978C765.823 778.978 765.14 779.032 764.488 779.139C763.837 779.232 763.24 779.419 762.698 779.693C762.149 779.961 761.67 780.335 761.238 780.816C760.814 781.291 760.468 781.899 760.201 782.648V782.808V797.254H756.299V784.038C756.299 782.448 755.993 781.204 755.388 780.308C754.776 779.419 753.583 778.978 751.8 778.978C751.046 778.978 750.34 779.025 749.672 779.112C749.005 779.205 748.4 779.386 747.859 779.653C747.309 779.927 746.83 780.308 746.406 780.816C745.982 781.318 745.613 781.966 745.307 782.762V797.254H741.405V776.391H745.307V779.139C746.069 777.895 747.066 777.066 748.306 776.639C749.547 776.217 750.905 776.004 752.397 776.004C754.328 776.004 755.875 776.311 757.022 776.913C758.168 777.521 759 778.35 759.518 779.406C759.88 778.738 760.343 778.176 760.9 777.742C761.458 777.307 762.086 776.959 762.761 776.699C763.444 776.438 764.159 776.264 764.897 776.164C765.635 776.057 766.381 776.004 767.142 776.004Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.245 689.861H134.591C142.466 689.861 148.991 688.397 154.15 685.476C165.762 678.764 171.565 667.294 171.565 651.063C171.565 636.184 165.904 625.388 154.581 618.677C149.564 615.749 143.118 614.285 135.235 614.285H115.245V689.861ZM84.9453 713.103V591.042H139.318C154.079 591.042 166.477 594.518 176.511 601.477C193.706 613.436 202.304 630.207 202.304 651.799C202.304 663.998 199.359 674.834 193.486 684.286C187.613 693.738 179.228 701.091 168.338 706.332C159.018 710.844 145.772 713.103 128.569 713.103H84.9453Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.985 646.124C256.957 646.124 250.943 648.29 245.926 652.622C240.909 656.953 238.404 662.167 238.404 668.27C238.404 674.246 240.877 679.373 245.824 683.638C250.763 687.916 256.745 690.042 263.773 690.042C270.933 690.042 277.026 687.916 282.043 683.638C287.053 679.373 289.565 674.186 289.565 668.083C289.565 662.114 287.053 656.953 282.043 652.622C277.026 648.29 271.004 646.124 263.985 646.124ZM318.797 713.104H289.345V705.784C279.311 712.255 269.073 715.484 258.606 715.484C244.709 715.484 232.955 710.844 223.36 701.573C213.758 692.301 208.96 681.018 208.96 667.722C208.96 654.667 213.907 643.718 223.792 634.867C233.677 626.03 245.926 621.605 260.546 621.605C270.439 621.605 280.033 624.653 289.345 630.75V623.985H318.797V713.104Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.418 713.103V623.984H365.87V636.244C372.175 627.34 380.772 622.888 391.655 622.888C394.238 622.888 396.46 623.256 398.321 623.984V646.124C390.014 646.251 384.494 646.611 381.769 647.22C371.162 649.419 365.87 655.763 365.87 666.258V713.103H336.418Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.046 623.984H484.953L507.307 675.77L531.592 623.984H561.467L517.404 713.103H494.194L472.273 662.227L455.046 623.984ZM475.358 713.103H445.012L404.387 623.984H434.695L458.336 675.77L475.358 713.103Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.011 705.966L561.531 623.986H594.202L619.987 674.675L648.15 623.986H679.965L612.041 746.04H581.302L603.011 705.966Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.763 713.103V623.984H715.207V634.051C725.383 625.749 736.202 621.604 747.665 621.604C755.258 621.604 762.034 623.222 767.978 626.457C773.921 629.686 778.185 633.991 780.768 639.359C782.77 643.63 783.775 649.967 783.775 658.383V713.103H754.324V661.679C754.324 650.95 748.6 645.575 737.136 645.575C730.392 645.575 725.061 647.099 721.119 650.154C717.178 653.202 715.207 657.354 715.207 662.594V713.103H685.763Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M801.185 713.103V623.984H830.636V634.051C840.804 625.749 851.624 621.604 863.087 621.604C870.68 621.604 877.456 623.222 883.399 626.457C889.343 629.686 893.606 633.991 896.19 639.359C898.192 643.63 899.197 649.967 899.197 658.383V713.103H869.753V661.679C869.753 650.95 864.021 645.575 852.558 645.575C845.814 645.575 840.482 647.099 836.541 650.154C832.599 653.202 830.636 657.354 830.636 662.594V713.103H801.185Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.806 480.286C533.274 473.842 540.011 457.992 546.01 457.17C547.392 456.976 550.195 457.204 551.632 458.761C562.066 470.065 553.469 492.057 547.478 500.948C540.969 510.593 536.784 514.263 530.346 516.89C528.65 502.505 529.349 491.101 531.806 480.286ZM409.635 554.351C402.592 529.925 422.653 490.974 432.656 475.112C446.38 453.333 470.673 442.143 477.591 442.143C477.905 442.143 478.211 442.157 478.501 442.183C479.789 442.31 481.689 442.745 483.369 445.131C488.159 451.929 482.624 466.255 475 480.419C462.092 504.43 441.505 538.114 409.635 554.351ZM588.613 363.88C589.304 363.586 590.387 363.212 591.73 362.744C600.963 359.515 622.587 351.948 621.519 337.242C620.914 328.946 614.916 324.02 609.624 319.668C605.651 316.413 602.165 313.545 600.814 309.561C609.969 300.055 612.592 291.8 608.611 285.015C596.841 264.995 566.683 262.869 544.047 272.508C529.357 278.772 509.233 287.341 501.138 301.118C497.243 307.763 495.657 314.842 494.126 321.694C492.187 330.37 490.357 338.559 483.911 344.053C470.399 355.558 454.664 365.511 439.447 375.137C418.515 388.386 396.868 402.082 379.602 420.445C361.441 439.784 341.051 467.725 338.287 488.187C334.416 516.917 338.154 534.063 352.577 553.702C353.841 555.434 356.526 555.962 358.56 554.879C360.593 553.796 361.214 551.517 359.942 549.785C346.712 531.757 338.436 502.953 353.417 479.149C367.896 456.147 374.789 451.508 396.664 428.233C413.223 410.605 431.219 397.971 450.11 383.352C465.656 371.313 476.091 361.173 490.051 349.287C498.398 342.182 500.565 332.469 502.661 323.077C504.082 316.72 505.55 310.149 508.919 304.421C515.71 292.849 533.369 288.765 548.224 284.922C567.602 279.921 588.134 277.007 597.36 288.324C599.448 290.884 602.526 296.359 593.504 305.483C593.449 305.53 593.402 305.584 593.355 305.637C591.675 306.7 584.679 310.691 572.855 311.526C570.46 311.7 568.685 313.485 568.882 315.524C569.07 317.455 570.97 318.913 573.208 318.913C573.326 318.913 573.451 318.913 573.569 318.899C582.528 318.264 589.217 316.092 593.559 314.18C595.915 318.692 597.76 321.165 600.108 324.996C603.649 330.758 608.972 332.275 609.365 337.696C610.048 347.115 595.938 353.272 588.424 355.899C586.83 356.46 585.543 356.915 584.726 357.262C582.017 358.412 579.882 360.986 578.351 364.889C574.323 375.103 578.272 389.121 579.167 391.467C583.415 402.631 588.291 419.696 589.367 430.713C590.183 438.995 588.236 454.637 585.975 472.745C579.874 521.717 576.349 560.554 591.903 573.489C584.514 574.231 570.876 574.204 562.608 574.184C559.138 574.177 555.848 574.171 552.943 574.191H552.927C548.02 574.191 542.539 557.005 540.741 551.356C539.532 547.566 538.574 544.571 537.593 542.613C534.79 537.044 532.835 530.915 531.563 524.584C540.262 521.155 546.96 516.957 551.718 513.221C571.19 497.913 572.823 469.303 557.779 456.495C553.626 452.952 548.546 451.736 543.466 453.052C533.015 455.773 525.651 462.177 520.822 475.399C516.566 487.05 519.785 504.096 522.054 520.126C521.764 520.239 521.481 520.346 521.199 520.453C508.895 525.126 490.326 529.538 485.851 535.868C472.15 555.247 495.328 568.021 505.111 574.438C483.087 575.414 431.486 577.232 419.112 568.449C416.426 566.544 414.291 564.157 412.642 561.396C447.236 544.324 477.151 509.811 486.934 482.117C492.132 467.411 494.393 450.058 488.921 443.38C485.953 439.75 482.325 437.337 477.575 436.882C464.408 435.599 437.775 446.201 418.915 470.493C405.45 487.819 392.762 530.607 401.917 557.947C391.655 562.292 381.353 564.839 371.696 564.859H371.539C355.035 564.859 339.025 558.997 326.486 550.24C268.753 509.972 276.432 460.345 280.923 440.873C284.456 425.539 292.253 399.028 312.392 374.796C327.852 356.206 350.002 333.325 384.462 329.902C389.087 329.334 399.608 329.281 402.608 332.75C404.037 334.394 406.753 334.749 408.685 333.532C410.616 332.322 411.032 330.002 409.603 328.358C402.71 320.397 385.177 322.322 383.332 322.569C317.559 329.093 274.092 401.915 265.44 439.449C260.658 460.225 256.143 513.167 317.504 555.968C331.699 565.875 352.883 572.259 371.531 572.259H371.719C382.468 572.232 393.814 569.511 405.042 564.846C407.177 568.455 409.98 571.597 413.553 574.131C422.935 580.788 446.043 582.673 471.49 582.673C484.06 582.673 497.204 582.212 509.547 581.644L512.256 581.517C513.85 581.443 518.089 581.256 519.204 578.121C520.351 574.886 517.249 572.921 512.947 570.2C500.965 562.613 490.122 554.01 500.25 539.685C503.179 535.54 513.716 531.403 523.421 527.713C524.803 533.943 526.813 539.986 529.608 545.527C530.346 547.011 531.319 550.059 532.348 553.295C536.384 565.949 541.346 581.651 553.029 581.591C555.895 581.57 559.153 581.571 562.585 581.584C593.606 581.664 602.196 580.969 603.9 575.975C604.481 574.284 604.238 571.758 599.754 569.338C583.745 560.695 597.242 508.234 601.568 473.527C603.876 455.044 605.667 439.088 604.983 430.104C603.178 406.18 586.202 383.539 585.582 375.137C585.362 372.189 585.708 369.515 586.603 367.209C587.49 364.916 588.385 364.014 588.613 363.88Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_d_3_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.201 386.551C597.913 386.551 596.641 386.063 595.778 385.14C594.301 383.529 594.623 381.203 596.516 379.946C603.606 375.2 613.192 371.918 623.337 368.449C636.08 364.091 649.255 359.585 656.832 352.138C661.857 347.205 666.356 339.304 671.114 330.935C680.01 315.306 690.099 297.592 708.213 290.821C725.4 284.403 743.726 279.27 749.363 289.858C750.439 291.877 750.415 293.962 749.308 295.888C747.079 299.751 740.789 302.572 726.884 305.734C729.711 309.036 732.372 313.622 731.148 318.395C729.821 323.595 724.403 327.399 715.067 329.725C712.79 330.3 710.349 329.17 709.681 327.205C709.006 325.246 710.333 323.194 712.633 322.619C718.506 321.162 718.593 319.103 719.182 316.824C720.14 313.114 718.004 307.953 715.97 306.436C714.738 305.52 714.212 304.103 714.604 302.753C714.997 301.409 716.19 300.106 717.815 300.039C737.201 299.29 747.518 296.041 744.299 290.56C740.114 283.441 721.16 289.504 708.825 295.507C694.425 302.505 689.455 315.534 681.211 330.012C676.194 338.829 674.734 351.798 668.955 357.466C660.004 366.27 640.281 370.628 626.58 375.314C617.024 378.583 607.995 381.671 601.886 385.762C601.085 386.297 600.143 386.551 599.201 386.551Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_65",
    x: 0,
    y: 0,
    width: 1008,
    height: 1008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3_65",
    x: 678.161,
    y: 224.153,
    width: 164.224,
    height: 131.425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3_65",
    x: 204.967,
    y: 776.004,
    width: 28.9167,
    height: 29.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3_65",
    x: 231.791,
    y: 783.998,
    width: 21.387,
    height: 10.7808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3_65",
    x: 251.161,
    y: 776.002,
    width: 25.8389,
    height: 29.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3_65",
    x: 273.717,
    y: 776.001,
    width: 30.644,
    height: 29.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3_65",
    x: 303.209,
    y: 776.004,
    width: 41.7698,
    height: 29.2503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3_65",
    x: 345.004,
    y: 776.004,
    width: 41.7698,
    height: 29.2503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_3_65",
    x: 385.353,
    y: 776.004,
    width: 28.9167,
    height: 29.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_3_65",
    x: 413.035,
    y: 776.004,
    width: 20.1621,
    height: 29.2503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_3_65",
    x: 427.92,
    y: 776.002,
    width: 25.8389,
    height: 29.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_3_65",
    x: 450.474,
    y: 776.004,
    width: 28.9167,
    height: 29.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_3_65",
    x: 500.03,
    y: 776.004,
    width: 28.9167,
    height: 29.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_3_65",
    x: 524.035,
    y: 776.389,
    width: 30.9661,
    height: 28.8626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_3_65",
    x: 549.672,
    y: 776.001,
    width: 30.6442,
    height: 29.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_3_65",
    x: 579.167,
    y: 767.895,
    width: 16.0322,
    height: 37.5927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_3_65",
    x: 591.962,
    y: 776.389,
    width: 27.7468,
    height: 29.2503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_3_65",
    x: 616.519,
    y: 771.447,
    width: 21.7482,
    height: 34.0365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_3_65",
    x: 634.902,
    y: 768.623,
    width: 12.6718,
    height: 36.6301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_3_65",
    x: 645.97,
    y: 776.001,
    width: 30.6442,
    height: 29.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_3_65",
    x: 675.466,
    y: 776.004,
    width: 27.9667,
    height: 29.2503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_3_65",
    x: 703.148,
    y: 768.623,
    width: 12.6715,
    height: 36.6301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_3_65",
    x: 714.218,
    y: 776.003,
    width: 24.4335,
    height: 29.4843,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_3_65",
    x: 737.405,
    y: 776.004,
    width: 41.7699,
    height: 29.2503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_3_65",
    x: 80.9453,
    y: 591.042,
    width: 125.358,
    height: 130.061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_3_65",
    x: 204.96,
    y: 621.605,
    width: 117.836,
    height: 101.878,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_3_65",
    x: 332.418,
    y: 622.888,
    width: 69.9023,
    height: 98.2153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_3_65",
    x: 400.387,
    y: 623.984,
    width: 165.08,
    height: 97.119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_3_65",
    x: 557.531,
    y: 623.986,
    width: 126.434,
    height: 130.054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_3_65",
    x: 681.763,
    y: 621.604,
    width: 106.012,
    height: 99.4987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_3_65",
    x: 797.185,
    y: 621.604,
    width: 106.012,
    height: 99.4987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_3_65",
    x: 258.915,
    y: 266.951,
    width: 366.642,
    height: 323.723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_3_65",
    x: 590.852,
    y: 283.767,
    width: 163.302,
    height: 110.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_65",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarwynnAvatar);
export default __webpack_public_path__ + "static/media/DarwynnAvatar.5161d2475f3ca3c64f8397018c24aca5.svg";
export { ForwardRef as ReactComponent };